var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_159_2507)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 0C17.9 0 0 17.6645 0 39.4738C0 56.941 11.45 71.6943 27.35 76.9246C29.35 77.27 30.1 76.0858 30.1 75.0496C30.1 74.1121 30.05 71.0035 30.05 67.6976C20 69.5233 17.4 65.2798 16.6 63.0594C16.15 61.9245 14.2 58.4212 12.5 57.4837C11.1 56.7436 9.1 54.9179 12.45 54.8686C15.6 54.8193 17.85 57.7304 18.6 58.9147C22.2 64.8851 27.95 63.2074 30.25 62.1713C30.6 59.6055 31.65 57.8785 32.8 56.8916C23.9 55.9048 14.6 52.5002 14.6 37.4014C14.6 33.1087 16.15 29.556 18.7 26.7928C18.3 25.806 16.9 21.7599 19.1 16.3323C19.1 16.3323 22.45 15.2961 30.1 20.3784C33.3 19.4902 36.7 19.0461 40.1 19.0461C43.5 19.0461 46.9 19.4902 50.1 20.3784C57.75 15.2468 61.1 16.3323 61.1 16.3323C63.3 21.7599 61.9 25.806 61.5 26.7928C64.05 29.556 65.6 33.0593 65.6 37.4014C65.6 52.5495 56.25 55.9048 47.35 56.8916C48.8 58.1252 50.05 60.4936 50.05 64.1943C50.05 69.4739 50 73.7173 50 75.0496C50 76.0858 50.75 77.3193 52.75 76.9246C68.55 71.6943 80 56.8916 80 39.4738C80 17.6645 62.1 0 40 0Z",
    fill: "#EF8244"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 38,
    stroke: "#DE6F31",
    strokeWidth: 4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_159_2507"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.dc2429d4cc0fae796b8098d2779f633e.svg";
export { ForwardRef as ReactComponent };